// removed by extract-text-webpack-plugin
module.exports = {"block":"_1J-GBsP9rg0epMQpcvTlgF","image":"Wc3hKKO_vJJjvIfCnXod_","failed":"_1phW4fuxKH4wmVulmiSydn","failedlabel":"U8D1gpvZO1fB3BwP1O8F-","icon":"_2UViBgcH_NNFroUaGBHwyJ","caption":"_1beYMFWs8X7bBrrOQNoqeD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WebcamBlockBody/WebcamBlockBody.module.scss
// module id = 819
// module chunks = 0